const HeadBar = ()=> (
    <div className="head-bar">
    </div>
);

export default HeadBar;